<template>
  <section>
    <!-- 按钮及日期行 -->
    <el-row style="padding:15px;background:#fff">
      <el-col :sm="12" :xs="24">
        <el-row :gutter="10">
          <el-button class="xs24" type="primary" plain @click="changeDate(1)" id="today">昨天</el-button>
          <el-button class="xs24" type="primary" plain @click="changeDate(7)" id="seven">最近7天</el-button>
          <el-date-picker
          	class="xs24"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
          
        </el-row>
      </el-col>
      <el-col :sm="12" :xs="24">
        <div style="float:right;text-align: right;">
        	 
          <el-row :gutter="10">
          	<!--<el-button class="xs24" type="primary" round @click="toogleChart" >图表</el-button>-->
            <el-select class="xs24" v-model="pdata.source" placeholder="请选择" @change="getList">
              <el-option label="请选择小游戏来源" value></el-option>
              <el-option label="内部发行" value="内部"></el-option>
              <el-option label="外部发行" value="外部"></el-option>
            </el-select>

            <searchApp class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
            <el-button type="primary" @click="fieldConfig">字段选择</el-button>
          </el-row>
        </div>
      </el-col>
    </el-row>

		
		<el-table :data="list" style="width: 100%;" stripe row-key="id" v-if="list.length>0">
			
			<el-table-column prop="d_date" label="日期" align="center" min-width="120px"></el-table-column>
			<el-table-column prop="issued_app_name" label="发行名称" align="center" min-width="120px"></el-table-column>

			<el-table-column :prop="item.key" :label="item.name" align="center" v-for="item in showFieldList"  sortable :sort-method="(a,b)=>{return parseFloat(a[item.key]) - parseFloat(b[item.key])}">
				<template slot="header" slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="'截至'+pdata.edate+'的累计数据'" placement="top-start" v-if="item.key=='ltv'">
						<span>{{item.name}}<i class="el-icon-question"></i></span>
					</el-tooltip>
					<span v-else>{{item.name}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				 <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="$router.push({
          name:'更多数据',
          params:{issued_app_id:scope.row.issued_app_id,edate:pdata.edate,sdate:pdata.sdate}
        })"
          >更多数据</el-button>
        </template>
			</el-table-column>
		</el-table>

		<!--<el-table  style="width: 100%;" stripe row-key="id"  v-if="list.length==0"></el-table>-->
		<div class="el-table el-table--fit el-table--striped el-table--enable-row-hover" style="width: 100%;" v-if="list.length==0">
			<div class="el-table__body-wrapper is-scrolling-none">
				<div class="el-table__empty-block" style="height: 100%; width: 100%"><span class="el-table__empty-text">暂无数据</span></div>
			</div>
		</div>
    <el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80,200,500]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>

    <el-drawer title="我是标题" size="580px" :visible.sync="drawer" direction="rtl" :with-header="false">
			<div class="filedFlex">
				<div class="fliedLeft">
					<div class="tit">设置显示字段</div>
					<div class="des">可选字段</div>
					<div class="fliedBtns" v-for="(value,key) in fieldList">
						<div class="key">{{key}}</div>
						<div class="btnsbox">

							<el-button :type="item.isCheck?'primary':''" :plain="item.isCheck?false:true" size="mini" v-for="(item,index) in value" @click.native="fliedTap(key,index)" :autofocus="false">{{item.name}}</el-button>

						</div>

					</div>
					<div class="fliedFt">
						<el-button type="success" @click="saveSelectField">确认并保存</el-button>
					</div>
				</div>
				<div class="fliedRight">
					<div class="tit">已选字段</div>
					<draggable v-model="selectFieldList" :move="onMove" @start="isDragging=true" @end="isDragging=false">
						<transition-group type="transition" tag="ul">
							<li v-for="item in selectFieldList" :key="item.key" class="item">
								<i class="el-icon-rank"></i> {{item.name}}
								<i class="el-icon-close" @click="removeSelectField(item)"></i>
							</li>
						</transition-group>
					</draggable>
				</div>
			</div>
		</el-drawer>
  </section>
</template>

<script>
import $ from "jquery";	
import { getTotalData, getDetailData,getTotalDataDay,getfieldFilter, postfieldFilter, getValidProductPlatform } from "../../api/api";
import echarts from "echarts";
import draggable from 'vuedraggable'

export default {
	components: {
		draggable
	},
  data() {
    return {
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_id:"",
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000  * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-17",
        // edate: "2019-04-17",
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000  * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      list: [], //所有数据
      height:600,
      drawer: false, //默认不展开
      fieldList: {
					'用户数据': [{
							"name": "活跃用户",
							"key": "visit_uv",
							"isCheck": false
					},
						{
							"name": "注册用户",
							"key": "visit_uv_new",
							"isCheck": false
						},
					],
					'收入数据': [{
							"name": "总流水",
							"key": "total_flow",
							"isCheck": false
						},
						{
							"name": "总收入",
							"key": "total_income",
							"isCheck": false
						},
						{
							"name": "广告流水",
							"key": "origin_income",
							"isCheck": false
						},
						{
							"name": "广告发行分成",
							"key": "origin_divide_income",
							"isCheck": false
						},
						{
							"name": "分发矩阵收入",
							"key": "matrix_income",
							"isCheck": false
						},
						{
							"name": "分发非矩阵收入",
							"key": "nonmatrix_income",
							"isCheck": false
						},
						{
							"name": "分发合计",
							"key": "distribution_income",
							"isCheck": false
						}
					],
					'支出数据': [{
							"name": "总支出",
							"key": "total_cost",
							"isCheck": false
						},
						{
							"name": "cp分成",
							"key": "cp_cost",
							"isCheck": false
						},
						{
							"name": "买量",
							"key": "expenses_cost",
							"isCheck": false
						}
						
					],
					'分发数据': [

						{
							"name": "跳出率",
							"key": "jump_per",
							"isCheck": false
						},
						{
							"name": "换入活跃",
							"key": "huanliang_in",
							"isCheck": false
						},
						{
							"name": "换出活跃",
							"key": "huanliang_out",
							"isCheck": false
						},
						{
							"name": "分发收入（含矩阵）",
							"key": "distribution_income",
							"isCheck": false
						},
						{
							"name": "arpu（含矩阵）",
							"key": "distribution_day_contribution",
							"isCheck": false
						},
						{
							"name": "分发收入（不含矩阵）",
							"key": "nonmatrix_income",
							"isCheck": false
						},
						{
							"name": "arpu（不含矩阵）",
							"key": "nonmatrix_day_contribution",
							"isCheck": false
						},
						{
							"name": "总arpu",
							"key": "total_day_contribution",
							"isCheck": false
						}
					],
					'利润': [{
							"name": "利润",
							"key": "profit",
							"isCheck": false
						},
						{
							"name": "ROI",
							"key": "roi",
							"isCheck": false
						},
						{
							"name": "单个用户价值",
							"key": "arpu",
							"isCheck": false
						}
						
					]
				},
				selectFieldList: [],
				showFieldList: [],
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getField();
        }
      },
      deep: true
    }
  },
  methods: {
  	getField() {
				console.log(this.pdata.platform_id)

				var _this = this;
				var p = "position=maindata_detail";
				getfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					console.log(res.data.content);
					if(res.data.content == null || res.data.content.length == 0) {
						
						res.data.content = ['visit_uv', 'visit_uv_new','total_income','total_cost','profit','roi','arpu'];
					
					}
					_this.selectFieldList = [];
					_this.showFieldList = [];
					_this.list = [];
					res.data.content.forEach((vv, ii) => {
						for(var key in _this.fieldList) {
							_this.fieldList[key].forEach((v, i) => {

								if(vv == v.key) {
									v.isCheck = true;
									_this.selectFieldList.push(v);
								}
							})
						}
					});
					this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					this.getList();
				})
			},
			saveSelectField() {
				var tempArr = [];
				this.selectFieldList.forEach((v, i) => {
					tempArr.push(v.key);
				})
				var p = {
					position: 'maindata_detail',
					content: tempArr,
				}
				postfieldFilter(p, this.$cookie.getCookie("login")).then(res => {
					this.drawer = false;
					this.showFieldList = JSON.parse(JSON.stringify(this.selectFieldList));
					this.getField();

				})
			},
			removeSelectField(obj) {
				this.removeArrForObjName(this.selectFieldList, obj);
				var fieldList_key;
				var fieldList_index;
				for(let key in this.fieldList) {
					this.fieldList[key].some((item, index) => {
						if(item.name == obj.name) {
							fieldList_key = key;
							this.fieldList[key][index].isCheck = false;

						}
					})
				}

			},
			onMove({
				relatedContext,
				draggedContext
			}) {
				const relatedElement = relatedContext.item;
				const draggedElement = draggedContext.item;
			},
			fieldConfig() {
				this.drawer = true
			},
			fliedTap(key, index) {
				this.fieldList[key][index].isCheck = !this.fieldList[key][index].isCheck;
				var result = this.selectFieldList.some(item => {
					if(item.name == this.fieldList[key][index].name) {
						return true
					}
				})
				if(this.fieldList[key][index].isCheck) {
					if(!result) {
						this.selectFieldList.push(this.fieldList[key][index])
					}
				} else {
					if(result) {
						this.removeArrForObjName(this.selectFieldList, this.fieldList[key][index])
					}
				}
			},
			removeArrForObjName(_arr, _obj) {
				var length = _arr.length;
				for(var i = 0; i < length; i++) {
					if(_arr[i].name == _obj.name) {
						_arr.splice(i, 1); //删除下标为i的元素
						return _arr;
					}
				}
			},
    getList() {
      var p = "";
	      var p = `issued_app_id=${this.pdata.issued_app_id}&sdate=${this.pdata.sdate}&edate=${
	          this.pdata.edate
	      }`;

        getTotalDataDay(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.list = res.data.list;
            this.$forceUpdate();
          }
         
        });
    },
    tableRowClassName({ row, rowIndex }) {
//    if (row.clickok_uv == 0 && row.num != 0) {
//      return "warning-row";
//    }
      return "";
   },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    updateBuy(id){
      console.log(id)
    },
    changeId(res) {
			this.pdata.issued_app_id = res;
			this.getList();
		},
  },
  created(){
  	
  },
  update(){
 
  },

  mounted() {

  	this.pdata.issued_app_id = this.$route.params.issued_app_id;
  	this.dateVal = [ this.$route.query.sdate,this.$route.query.edate];
//  this.getField()
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>

<style >
.total.el-row::before,
.total.el-row::after {
  content: table;
}
.total {
  min-width: 1200px;
  padding: 15px 10px;
  background: #f2f6fc;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  text-align: center;
}
.box-card {
  /* width: 260px; */
  margin: 10px;
  float: left;
}
.sicon {
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding: 10px;
  border-radius: 10px;
  background: #67c23a;
  text-align: center;
  font-size: 25px;
  color: white;
}
.sicon.c1 {
  background: #67c23a;
}
.sicon.c2 {
  background: #409eff;
}
.sicon.c3 {
  background: #e6a23c;
}
.sicon.c4 {
  background: #f56c6c;
}
.sicon.c5 {
  background: #909399;
}

.tjContent {
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
  margin-left: 10px;
}
.tjContent > div {
  height: 25px;
  line-height: 25px;
  font-size: 16px;
}

.tjContent > div.numText {
  font-size: 28px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  color: brown;
}
.tjContent > div.numText.t1 {
  color: #67c23a;
}
.tjContent > div.numText.t2 {
  color: #409eff;
}
.tjContent > div.numText.t3 {
  color: #e6a23c;
}
.tjContent > div.numText.t4 {
  color: #f56c6c;
}
.tjContent > div.numText.t5 {
  color: #909399;
}
</style>


<style>
	@media only screen and (max-width: 767px) {
	.total{
		min-width: 100% !important;
	}
	.xs24{
		width: 100% !important;
		margin: 5px 0;
	}
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 60px;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>

<style scoped="">
	.red {
		color: #FF0000;
	}
	
	.filedFlex {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		height: 100%;
	}
	
	.fliedLeft {
		width: 360px;
		border-right: 1px solid #E6E6E6;
		box-sizing: border-box;
		height: 100%;
		height:calc(100vh - 70px);
		overflow-y: auto;
	}
	
	.fliedRight {
		width: 220px;
		height: 100%;
		height: 100vh;
		overflow-y: auto;
	}
	
	.tit {
		padding: 0 10px;
		text-align: left;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		border-bottom: 1px solid #E6E6E6;
	}
	
	.filedFlex .des {
		padding: 0 15px;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
	}
	
	.filedFlex .key {
		padding: 0 15px;
		font-size: 14px;
		height: 50px;
		line-height: 50px;
		font-weight: bold;
	}
	
	.btnsbox {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
		padding: 5px;
	}
	
	.btnsbox button {
		margin: 5px;
	}
	
	.btnsbox button:focus {}
	
	.fliedRight ul {
		margin: 0;
		padding: 0;
	}
	
	.fliedRight ul li {
		line-height: 40px;
		list-style: none;
		border-bottom: 1px solid #E6E6E6;
		padding: 0 10px;
	}
	
	.fliedRight ul li i {
		margin-right: 5px;
	}
	
	.fliedRight ul li i.el-icon-close {
		float: right;
		cursor: pointer;
		margin-top: 15px;
	}
	
	.fliedFt {
		margin: 20px 0;
		padding: 0 10px;
	}
</style>


// WEBPACK FOOTER //
// totalDataDetail.vue?d9b5a0b2